import { ProfileState } from '@/types/field'
import { createSlice } from '@reduxjs/toolkit'

const initialState: ProfileState = {
    user: null
}

const profileSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        setProfile: (state, action) => {
            state.user = action.payload.user
        }
    }
})

export const { setProfile } = profileSlice.actions

export default profileSlice.reducer
